import { useState, useEffect ,memo,useCallback } from "react";
import axios from "axios";
import { showToast } from "../Buttons/Toaster";
import loading from "../../assests/loading .gif";
import nologs from "../../assests/nologs.gif";
import CustomTooltip from "../Buttons/CustomTooltip";
function CreateDatabase({
  show,
  setShow,
  DatabaseStep,
  setDatabaseStep,
  onJobExecuted,
  jobDetails,
  isViewingProgress = false,
  jobProgressData = null,
  fetchJobProgress,
  progressLoading,
  progressError,
  logs,
  isLogLoading,
  jobProcessCompleted,
  isStreaming,
  onMigrationStarted,
  onClose,
}) {
  const [selectedSourceDatabase, setSelectedSourceDatabase] = useState(null);
  const [connectionTestStatus, setConnectionTestStatus] = useState({
    source: null,
    target: null,
  });
  const [selectedTargetDatabase, setSelectedTargetDatabase] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [sourceConnection, setSourceConnection] = useState({});
  const [targetConnection, setTargetConnection] = useState({});
  const [selectedTables, setSelectedTables] = useState([]);
  const [isPaused, setIsPaused] = useState(false);
  const [availableSources, setAvailableSources] = useState([]);
  const [availableTargets, setAvailableTargets] = useState({});
  const [loadingPlatforms, setLoadingPlatforms] = useState(false);
  const modalStyle = {
    width: DatabaseStep === 4 ? "715px" : "",
  };
  const [sourceFields, setSourceFields] = useState([]);
  const [targetFields, setTargetFields] = useState([]);
  const [loadingFields, setLoadingFields] = useState(false);
  const [sourceConnectionString, setSourceConnectionString] = useState("");
  const [targetConnectionString, setTargetConnectionString] = useState("");
  const [sampleTables, setSampleTables] = useState([]); // Initialize as empty array
  const [expandedSchemas, setExpandedSchemas] = useState({});
  const [checkedTables, setCheckedTables] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [jobName, setJobName] = useState("");
  const [jobDescription, setJobDescription] = useState("");
  const [isJobCreated, setIsJobCreated] = useState(false);
  const [isMigrationStarting, setIsMigrationStarting] = useState(false);
  const [jobId, setJobId] = useState(null);
  const [duplicateJobError, setDuplicateJobError] = useState(null);
  const [jobNameError, setJobNameError] = useState("");
  const [migrationStarted, setMigrationStarted] = useState(false);
  const [sourceConnectionDetails, setSourceConnectionDetails] = useState("");
  const [targetConnectionDetails, setTargetConnectionDetails] = useState("");
  const capitalizeFirstLetter = (str) => {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const validateJobName = (name) => {
    // Allows letters, numbers, spaces, hyphens, and underscores
    // return /^[a-zA-Z0-9 _-]+$/.test(name);
    return /^[a-zA-Z0-9 ]+$/.test(name);
  };
  const limitDescription = (text) => {
    return text.length <= 500 ? text : text.substring(0, 500);
  };

  const [fieldErrors, setFieldErrors] = useState({
    jobName: false,
    sourceFields: {},
    targetFields: {},
  });

  const [isDatabaseSelected, setIsDatabaseSelected] = useState(false);
  const [connectionTested, setConnectionTested] = useState(false);
  useEffect(() => {
    if (isViewingProgress) {
      setDatabaseStep(4);
    }
  }, [isViewingProgress, setDatabaseStep]);

  // Add these helper functions

  const handleSchemaToggle = (schemaName) => {
    setExpandedSchemas((prev) => ({
      ...prev,

      [schemaName]: !prev[schemaName],
    }));
  };

  const isSchemaChecked = (schemaName, tables) => {
    if (!tables || tables.length === 0) return false;

    const normalizedSchema = schemaName.toLowerCase();
    const schemaTables = checkedTables.filter((t) =>
      t.toLowerCase().startsWith(`${normalizedSchema}.`)
    );

    if (schemaTables.length === 0) return false;
    if (schemaTables.length === tables.length) return true;
    return "indeterminate"; // For intermediate state
  };
  // In your handleTableSelect function, normalize the names:
  const handleTableSelect = (schemaName, tableName) => {
    const fullTableName = `${schemaName}.${tableName}`;

    setCheckedTables((prev) => {
      // Check if the table is already selected
      const isSelected = prev.some(
        (t) => t.toLowerCase() === fullTableName.toLowerCase()
      );

      if (isSelected) {
        // Remove the table if it's already selected
        return prev.filter(
          (t) => t.toLowerCase() !== fullTableName.toLowerCase()
        );
      } else {
        // Add the table if it's not selected
        return [...prev, fullTableName];
      }
    });
  };

  // Update the handleSelectAllTables function
  const handleSelectAllTables = () => {
    const allTables = Object.entries(sampleTables.schemas || {}).flatMap(
      ([schemaName, tables]) => tables.map((table) => `${schemaName}.${table}`)
    );

    if (checkedTables.length === allTables.length) {
      // Deselect all
      setCheckedTables([]);
    } else {
      // Select all
      setCheckedTables([...allTables]);
    }
  };

  // If you have search functionality, update it to handle schema.table format
  const filteredTables = Object.entries(sampleTables.schemas || {}).filter(
    ([schemaName, tables]) =>
      schemaName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      tables.some((table) =>
        table.toLowerCase().includes(searchTerm.toLowerCase())
      )
  );

  // Start at 75% progress

  const [migrationProgress] = useState(75);

  // Fetch platform data when component mounts or show changes

  useEffect(() => {
    if (show) {
      fetchDatabaseDetails();
    }
  }, [show]);

  // Fetch connection fields when source or target database changes
  useEffect(() => {
    if (selectedSourceDatabase) {
      fetchConnectionFields(selectedSourceDatabase, true);
    }
  }, [selectedSourceDatabase]);

  useEffect(() => {
    if (selectedTargetDatabase) {
      fetchConnectionFields(selectedTargetDatabase, false);
    }
  }, [selectedTargetDatabase]);

  const fetchDatabaseDetails = async () => {
    const access_token = sessionStorage.getItem("access_token");

    if (!access_token) {
      showToast("Authentication required", "error");

      return;
    }

    setLoadingPlatforms(true);
 const wsBaseDB = process.env.REACT_APP_API_URL_DATA_MIGRATION
    try {
      const response = await axios.get(
           `${wsBaseDB}/get-platforms`,
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );

      if (response.data) {
        setAvailableSources(Object.keys(response.data));

        setAvailableTargets(response.data);
      }
    } catch (error) {
      console.error("Error fetching databases:", error);
    } finally {
      setLoadingPlatforms(false);
    }
  };

  const fetchConnectionFields = async (databaseName, isSource) => {
    const access_token = sessionStorage.getItem("access_token");

    if (!access_token) {
      showToast("Authentication required", "error");
      return;
    }
    setLoadingFields(true);
    const wsBaseConnection = process.env.REACT_APP_API_URL_DATA_MIGRATION
    try {
      const response = await axios.get(
        `${wsBaseConnection}/get_fields?source_database=${databaseName}${
          !isSource && selectedSourceDatabase
            ? `&migration_source=${selectedSourceDatabase}`
            : ""
        }`,

        {
          headers: {
            Authorization: `Bearer ${access_token}`,
            accept: "application/json",
          },
        }
      );

      // Try different cases for the database key to be robust
      const fields = response.data[databaseName] || 
                     response.data[databaseName.toLowerCase()] || 
                     Object.values(response.data)[0] || [];

      if (isSource) {
        setSourceFields(fields);
        const initialConnection = {};

        fields.forEach((field) => {
          initialConnection[field.field_name] = field.field_default || "";
        });

        setSourceConnection(initialConnection);
      } else {
        setTargetFields(fields);
        const initialConnection = {};

        fields.forEach((field) => {
          initialConnection[field.field_name] = field.field_default || "";
        });

        setTargetConnection(initialConnection);
      }
    } catch (error) {
      console.error("Error fetching connection fields:", error);
    } finally {
      setLoadingFields(false);
    }
  };

  const getTargetDatabases = () => {
    if (!selectedSourceDatabase) return [];

    return availableTargets[selectedSourceDatabase] || [];
  };

  const getDatabaseImagePath = useCallback((dbName) => {
    const normalized = dbName ? String(dbName).trim().toLowerCase().replace(/\s+/g, "-") : "";

    return `assets/images/${normalized}.png`;
  }, []);

  const getCustomImageStyle = (rawDbName) => {
    const dbName = rawDbName ? String(rawDbName).trim() : "";
    if (dbName === "Oracle") {
      return {
        width: "59px",

        height: "40px",

        objectFit: "contain",
      };
    }

    return {
      width: "45px",

      height: "27px",

      objectFit: "contain",
    };
  };

  const highlightKeywords = (text) => {
    if (!text) return text;
    const greenKeywords = ["completed", "successfully"];
    const yellowKeywords = [
      "SQL",
      "T-SQL",
      "output",
      "progress",
      "Transforming",
      "Converting",
      "folder",
      "file",
    ];
    const redKeywords = ["of", "table", "queries", "Transformimg"];
    const newWords = ["Started", "database", "data"];
    const errorWords = ["error", "failed"];

    const regex = new RegExp(
      `\\b(${[
        ...greenKeywords,
        ...yellowKeywords,
        ...redKeywords,
        ...newWords,
        ...errorWords,
      ].join("|")})\\b`,
      "gi"
    );

    return text.split(regex).map((part, index) => {
      if (
        greenKeywords.some((word) => word.toLowerCase() === part.toLowerCase())
      ) {
        return (
          <span key={index} style={{ color: "#57FFEF", fontWeight: "bold" }}>
            {part}
          </span>
        );
      } else if (
        yellowKeywords.some((word) => word.toLowerCase() === part.toLowerCase())
      ) {
        return (
          <span key={index} style={{ color: "#FFD03C", fontWeight: "bold" }}>
            {part}
          </span>
        );
      } else if (
        redKeywords.some((word) => word.toLowerCase() === part.toLowerCase())
      ) {
        return (
          <span key={index} style={{ color: "#F97583", fontWeight: "bold" }}>
            {part}
          </span>
        );
      } else if (
        newWords.some((word) => word.toLowerCase() === part.toLowerCase())
      ) {
        return (
          <span key={index} style={{ color: "#B392F0", fontWeight: "bold" }}>
            {part}
          </span>
        );
      } else if (
        errorWords.some((word) => word.toLowerCase() === part.toLowerCase())
      ) {
        return (
          <span key={index} style={{ color: "#ec9395", fontWeight: "bold" }}>
            {part}
          </span>
        );
      }
      return part;
    });
  };

  const handleClose = () => {
    // **NEW: Call onClose to cleanup intervals**
    if (onClose) {
      onClose();
    }

    setShow(false);
    setTimeout(() => {
      setDatabaseStep(1);
      setSelectedSourceDatabase(null);
      setSelectedTargetDatabase(null);
      setSourceConnection({
        hostname: "",
        port: "",
        dbName: "",
        credentials: "",
      });
      setTargetConnection({
        hostname: "",
        port: "",
        dbName: "",
        credentials: "",
      });
      setSelectedTables([]);
      setIsPaused(false);
      setMigrationStarted(false);
    }, 300);
  };
  const handleNext = async () => {
    setFieldErrors({
      jobName: false,
      sourceFields: {},
      targetFields: {},
    });
    if (DatabaseStep === 1) {
      // Validate job name
      if (!jobName.trim()) {
        setFieldErrors((prev) => ({ ...prev, jobName: true }));
        showToast("Job name is required", "error");
        return;
      }
      if (!validateJobName(jobName)) {
        setJobNameError("Only letters, numbers, and spaces are allowed.");
        return;
      }
      if (!selectedSourceDatabase) {
        showToast("Please select a source database", "error");
        return;
      }
      if (connectionTestStatus.source !== true) {
        showToast(
          "Please test the source connection successfully before proceeding",
          "error"
        );
        return;
      }
      const sourceMissingFields = {};
      let hasSourceErrors = false;
      sourceFields.forEach((field) => {
        if (field.is_required && !sourceConnection[field.field_name]?.trim()) {
          sourceMissingFields[field.field_name] = true;
          hasSourceErrors = true;
        }
      });
      if (hasSourceErrors) {
        setFieldErrors((prev) => ({
          ...prev,
          sourceFields: sourceMissingFields,
        }));
        showToast("Please fill all required connection fields", "error");
        return;
      }
      if (connectionTestStatus.source === false) {
        showToast(
          "Source connection test failed. Please test connection again.",
          "error"
        );
        return;
      }
      if (connectionTestStatus.source === null) {
        showToast("Please test the source connection first", "error");
        return;
      }
    }

    if (DatabaseStep === 2) {
      if (!selectedTargetDatabase) {
        showToast("Please select a target database", "error");
        return;
      }

      const targetMissingFields = {};
      let hasTargetErrors = false;

      targetFields.forEach((field) => {
        if (field.is_required && !targetConnection[field.field_name]?.trim()) {
          targetMissingFields[field.field_name] = true;
          hasTargetErrors = true;
        }
      });

      if (hasTargetErrors) {
        setFieldErrors((prev) => ({
          ...prev,
          targetFields: targetMissingFields,
        }));
        showToast("Please fill all required connection fields", "error");
        return;
      }

      if (connectionTestStatus.target === false) {
        showToast(
          "Target connection test failed. Please test connection again.",
          "error"
        );
        return;
      }

      if (connectionTestStatus.target === null) {
        showToast("Please test the target connection first", "error");
        return;
      }
    }

    if (DatabaseStep === 3) {
      const wsBaseCreate = process.env.REACT_APP_API_URL_DATA_MIGRATION
      try {
        setIsLoading(true);
        const access_token = sessionStorage.getItem("access_token");
        if (!access_token) {
          showToast("Authentication required", "error");
          return;
        }

        // Prepare schema_tables data
        const schemaTablesMap = {};
        Object.entries(sampleTables.schemas || {}).forEach(
          ([schemaName, tables]) => {
            const selectedTables = tables.filter((table) =>
              checkedTables.includes(`${schemaName}.${table}`)
            );
            if (selectedTables.length > 0) {
              schemaTablesMap[schemaName] = selectedTables;
            }
          }
        );

        // Create URL with query parameters
        const url = new URL( `${wsBaseCreate}/create_job`);
        const params = {
          job_name: jobName,

          source_db: selectedSourceDatabase,
          target_db: selectedTargetDatabase,
          source_conn_string: sourceConnectionString,
          target_conn_string: targetConnectionString,
          source_conn_details: sourceConnectionDetails,
          target_conn_details: targetConnectionDetails,
          schema_tables: JSON.stringify(schemaTablesMap),
          job_description: jobDescription || "",
        };

        // Add params to URL
        Object.entries(params).forEach(([key, value]) => {
          url.searchParams.append(key, value);
        });

        const response = await axios.post(url.toString(), null, {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        });

        if (response.data) {
          showToast("Migration job created successfully", "success");
          setIsJobCreated(true);
          setJobId(response.data.job_id); // Store the job ID
          if (onJobExecuted) onJobExecuted();
          // setDatabaseStep(4);
        }
      } catch (error) {
        console.error("Error creating job:", error);
        let errorMessage = "Failed to create job";
        if (error.response?.data?.detail) {
          errorMessage = Array.isArray(error.response.data.detail)
            ? error.response.data.detail
                .map((err) => `${err.loc[1]}: ${err.msg}`)
                .join(", ")
            : error.response.data.detail;
        }
        showToast(errorMessage, "error");
      } finally {
        setIsLoading(false);
      }
      return; // Add this to prevent moving to next step
    }
    if (DatabaseStep !== 3) {
      setDatabaseStep(DatabaseStep + 1);
    }

    if (DatabaseStep === 2) {
      const wsBaseSchemas = process.env.REACT_APP_API_URL_DATA_MIGRATION
      try {
        setIsLoading(true);
        const params = new URLSearchParams();
        params.append("db_type", selectedSourceDatabase.toLowerCase());
        params.append("db_name", sourceConnection.database || "dbshift-db");
        params.append("source_conn_string", sourceConnectionString);

        const url =  `${wsBaseSchemas}/get-database-schemas?${params.toString()}`;
        const response = await axios.post(
          url,
          {},
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        );

        if (response.data && response.data.schemas) {
          setSampleTables(response.data);
        } else {
          showToast("No schemas found in the source database", "warning");
          setSampleTables({ schemas: null });
        }
      } catch (error) {
        console.error("Error:", error);
        showToast("Failed to fetch database schemas", "error");
        setSampleTables({ schemas: null });
      } finally {
        setIsLoading(false);
      }
    }

    setDatabaseStep(DatabaseStep + 1);
  };

  // Modify handleStartMigration to ensure proper WebSocket handling
  const handleStartMigration = async () => {
    if (!jobId) {
      showToast("No job ID found", "error");
      return;
    }

    setIsMigrationStarting(true);
const wsBaseInitiate = process.env.REACT_APP_API_URL_DATA_MIGRATION
    try {
      const access_token = sessionStorage.getItem("access_token");
      if (!access_token) {
        showToast("Authentication required", "error");
        setIsMigrationStarting(false);
        return;
      }

      // Start the API call
      const apiCall = axios.post(
           `${wsBaseInitiate}/initiate_database_migration?job_id=${jobId}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );

      // Set up a timer to move to step 4 after 2 seconds
      const step4Timer = setTimeout(() => {
        setDatabaseStep(4);
        if (onMigrationStarted) {
          onMigrationStarted(jobId);
        }
      }, 2000);

      // Wait for API to complete (but don't block step 4 transition)
      apiCall
        .then(() => {
          // API succeeded - clear the timer if it hasn't fired yet
          clearTimeout(step4Timer);
        })
        .catch((error) => {
          // API failed - show error but don't prevent step 4 transition
          console.error("API Error:", error);
          showToast("Migration initiation failed", "error");
        })
        .finally(() => {
          setIsMigrationStarting(false);
        });
    } catch (error) {
      console.error("Unexpected error:", error);
      setDatabaseStep(4);
      if (onMigrationStarted) onMigrationStarted(jobId);
      setIsMigrationStarting(false);
    }
  };
  const handlePrevious = () => {
    setDatabaseStep(DatabaseStep - 1);
  };

  const handleDatabaseSelect = (db, isSource = true) => {
    if (isSource) {
      setSelectedSourceDatabase(db);
      setIsDatabaseSelected(true);

      setFieldErrors((prev) => ({
        ...prev,
        sourceFields: {},
      }));

      setSelectedTargetDatabase(null);
      setTargetConnection({});
      setTargetConnectionString("");
      setTargetConnectionDetails("");
      // Reset connection tested status if changing databases
      if (selectedSourceDatabase !== db) {
        setConnectionTested(false);
        setSourceConnectionString("");
        setSourceConnectionDetails("");
        setConnectionTestStatus((prev) => ({ ...prev, source: null }));
      }
      // Fetch connection fields for the new database
      fetchConnectionFields(db, true);
    } else {
      // Set the selected target database
      setSelectedTargetDatabase(db);

      // Reset any target field errors
      setFieldErrors((prev) => ({
        ...prev,
        targetFields: {},
      }));
      // Reset connection string if changing databases
      if (selectedTargetDatabase !== db) {
        setTargetConnectionString("");
        setTargetConnectionDetails("");
        setConnectionTestStatus((prev) => ({ ...prev, target: null }));
      }
      // Fetch connection fields for the new database
      fetchConnectionFields(db, false);
    }
  };

  const handleSelectAll = () => {
    if (selectedTables.length === sampleTables.length) {
      setSelectedTables([]);
    } else {
      setSelectedTables([...sampleTables]);
    }
  };

  const handleTestConnection = async (isSource = true) => {
    const connection = isSource ? sourceConnection : targetConnection;
    const selectedDb = isSource
      ? selectedSourceDatabase
      : selectedTargetDatabase;
    const fields = isSource ? sourceFields : targetFields;

    if (!selectedDb) {
      showToast(
        `Please select a ${isSource ? "source" : "target"} database first`,
        "error"
      );
      return;
    }

    const dbTypeMap = {
      postgresql: "postgres",
      oracle: "oracle",
      snowflake: "snowflake",
      redshift: "redshift",
      databricks: "databricks",
      bigquery: "bigquery",
      "SQL Server" :" sql server",
      mysql: "mysql",
    };

    const dbType =
      dbTypeMap[selectedDb.toLowerCase()] || selectedDb.toLowerCase();

    setFieldErrors((prev) => ({
      ...prev,
      [isSource ? "sourceFields" : "targetFields"]: {},
    }));

    const requiredFields = fields.filter((field) => field.is_required);
    const missingFields = {};
    let hasErrors = false;

    requiredFields.forEach((field) => {
      const value = connection[field.field_name];
      if (value === undefined || value === null || value === "") {
        missingFields[field.field_name] = true;
        hasErrors = true;
      }
    });

    if (hasErrors) {
      setFieldErrors((prev) => ({
        ...prev,
        [isSource ? "sourceFields" : "targetFields"]: missingFields,
      }));
      return;
    }
const wsBaseTest = process.env.REACT_APP_API_URL_DATA_MIGRATION
    try {
      setIsLoading(true);

      const payload = {
        ...connection,
        db_type: dbType,
        host: connection.host || connection.hostname || "",
        port: connection.port ? parseInt(connection.port) : null,
        database:
          dbType === "oracle"
            ? null
            : connection.database || connection.dbName || null,
        service_name:
          dbType === "oracle" ? connection.service_name || null : null,
      };

      const response = await axios.post(
           `${wsBaseTest}/test_db_connection`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data && response.data.status === "success") {
        if (isSource) {
          setSourceConnectionString(response.data.connection_string);
          setSourceConnectionDetails(response.data.connection_details);
          setConnectionTestStatus((prev) => ({ ...prev, source: true }));
          setConnectionTested(true);
        } else {
          setTargetConnectionString(response.data.connection_string);
          setTargetConnectionDetails(response.data.connection_details);
          setConnectionTestStatus((prev) => ({ ...prev, target: true }));
        }
        showToast(`Successfully connected to ${selectedDb}`, "success");
      } else {
        showToast(`Connection to ${selectedDb} failed`, "error");
        setConnectionTestStatus((prev) => ({
          ...prev,
          [isSource ? "source" : "target"]: false,
        }));
        if (isSource) {
          setConnectionTested(false);
        }
      }
    } catch (error) {
      showToast(
        `Connection to ${selectedDb} failed: ${error.message}`,
        "error"
      );
      setConnectionTestStatus((prev) => ({
        ...prev,
        [isSource ? "source" : "target"]: false,
      }));
      if (isSource) {
        setConnectionTested(false);
      }
    } finally {
      setIsLoading(false);
    }
  };
  const logContainerStyle =
    (logs?.length || 0) > 0
      ? { height: "40vh", overflowY: "auto" }
      : {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "40vh",
        };

  const calculateProgressPercentage = (job) => {
    if (!job || !job.tables) return 0;

    const totalTables = job.tables.length;
    if (totalTables === 0) return 0;

    // Count completed tables (assuming 'completed' status)
    const completedTables = job.tables.filter(
      (table) => table.status?.toLowerCase() === "completed"
    ).length;

    // Calculate percentage
    return Math.round((completedTables / totalTables) * 100);
  };

  const renderConnectionFields = (
    fields,
    connection,
    setConnection,
    isSource
  ) => {
    const currentErrors = isSource
      ? fieldErrors.sourceFields
      : fieldErrors.targetFields;

    return (
      <div className="connection-fields-container">
        <h6 className="fw-sbold font-size-12 mb-3">
          {isSource ? "Source" : "Target"} Database Connection Details
        </h6>

        {fields
          .sort((a, b) => a.field_order - b.field_order)
          .map((field) => (
            <div className="mb-3" key={field.field_name}>
              {field.field_type === "boolean" ? (
                <div className="d-flex align-items-center mb-2">
                  <input
                    type="checkbox"
                    className="custom-checkbox me-2"
                    id={`${isSource ? "source" : "target"}-field-${field.field_name}`}
                    checked={
                      connection[field.field_name] === true ||
                      connection[field.field_name] === "true"
                    }
                    onChange={(e) => {
                      setConnection({
                        ...connection,
                        [field.field_name]: e.target.checked ? "true" : "false",
                      });
                      if (currentErrors[field.field_name]) {
                        setFieldErrors((prev) => ({
                          ...prev,
                          [isSource ? "sourceFields" : "targetFields"]: {
                            ...prev[isSource ? "sourceFields" : "targetFields"],
                            [field.field_name]: false,
                          },
                        }));
                      }
                    }}
                  />
                  <label
                    className="font-size-12 mb-0 cursor-pointer text-dark"
                    htmlFor={`${isSource ? "source" : "target"}-field-${field.field_name}`}
                  >
                    {field.placeholder || field.field_name}
                  </label>
                </div>
              ) : (
                <>
                  <input
                    type={
                      field.field_type === "password"
                        ? "password"
                        : field.field_type === "number"
                        ? "number"
                        : "text"
                    }
                    className={`form-control highlighted-input font-size-12 colorfor-placeholder styled-input ${
                      currentErrors[field.field_name] ? "is-invalid" : ""
                    }`}
                    value={connection[field.field_name] || ""}
                    onChange={(e) => {
                      setConnection({
                        ...connection,
                        [field.field_name]: e.target.value,
                      });
                      if (currentErrors[field.field_name]) {
                        setFieldErrors((prev) => ({
                          ...prev,
                          [isSource ? "sourceFields" : "targetFields"]: {
                            ...prev[isSource ? "sourceFields" : "targetFields"],
                            [field.field_name]: false,
                          },
                        }));
                      }
                    }}
                    placeholder={field.placeholder || field.field_name}
                    style={
                      currentErrors[field.field_name]
                        ? { border: "1px solid #dc3545" }
                        : {}
                    }
                  />
                  {currentErrors[field.field_name] && (
                    <div className="text-danger font-size-10 mt-1">
                      This field is required
                    </div>
                  )}
                </>
              )}
            </div>
          ))}
      </div>
    );
  };
  const stepInfo = {
    1: {
      title:
        "Choose Source Database Server and Source Database Connection Details",

      description:
        "Select a database and enter its connection details to proceed with migration",

      content: (
        <>
          <div className="mb-2">
            <h6 className="fw-sbold font-size-12">
              Job Name <span style={{ color: "red" }}>*</span>
            </h6>
            <input
              type="text"
              placeholder="Enter job name"
              className={`form-control highlighted-input colorfor-placeholder font-size-12 doc-search mb-3 styled-input ${
                fieldErrors.jobName || duplicateJobError || jobNameError
                  ? "is-invalid"
                  : ""
              }`}
              style={
                fieldErrors.jobName || jobNameError
                  ? { border: "1px solid #dc3545" }
                  : {}
              }
              value={jobName}
              onChange={(e) => {
                const newName = capitalizeFirstLetter(e.target.value);
                if (validateJobName(newName) || newName === "") {
                  setJobName(newName);
                  setJobNameError("");
                  // Clear job name error when user starts typing
                  if (fieldErrors.jobName) {
                    setFieldErrors((prev) => ({ ...prev, jobName: false }));
                  }
                } else {
                  setJobNameError(
                    "Only letters, numbers, and spaces are allowed."
                  );
                }
              }}
            />
            {fieldErrors.jobName && (
              <div
                className="text-danger font-size-10"
                style={{ marginTop: "-14px" }}
              >
                Job name is required
              </div>
            )}
            {jobNameError && !fieldErrors.jobName && (
              <div
                className="text-danger font-size-10"
                style={{ marginTop: "-14px" }}
              >
                {jobNameError}
              </div>
            )}
            <h6 className="fw-sbold font-size-12 ">Job Description</h6>
            <textarea
              rows="5"
              placeholder="Description"
              className="form-control highlighted-input colorfor-placeholder styled-input font-size-12 doc-search  mb-3 capitalize-first "
              style={{ height: "80px" }}
              value={jobDescription}
              onChange={(e) => {
                const limitedText = limitDescription(e.target.value);
                setJobDescription(capitalizeFirstLetter(limitedText));
              }}
            ></textarea>
            <div
              className="d-flex flex-justify-start font-size-10 text-muted text-end"
              style={{ marginTop: "-15px" }}
            >
              {jobDescription.length}/500 characters
            </div>
          </div>

          <h6 className="fw-sbold font-size-12 mb-3">
            Choose Source Database Type
          </h6>

          {loadingPlatforms ? (
            <div className="grid-container ms-2 mb-4">
              {/* First placeholder database */}
              <div
                className="grid-item loadingStyle"
                style={{ height: "80px" }}
              >
                <div
                  className="loadingStyle"
                  style={{
                    width: "45px",
                    height: "27px",
                    margin: "0 auto 8px",
                  }}
                ></div>
                {/* <div className="loadingStyle" style={{
                  width: '80px',
                  height: '12px',
                  margin: '0 auto'
                }}></div> */}
              </div>

              {/* Second placeholder database */}
              <div
                className="grid-item loadingStyle"
                style={{ height: "80px" }}
              >
                <div
                  className="loadingStyle"
                  style={{
                    width: "45px",
                    height: "27px",
                    margin: "0 auto 8px",
                  }}
                ></div>
                {/* <div className="loadingStyle" style={{
                  width: '80px',
                  height: '12px',
                  margin: '0 auto'
                }}></div> */}
              </div>
            </div>
          ) : (
            <>
              <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-6 g-2 ms-2 mb-4">
                {availableSources.map((db) => (
                  <div key={db} className="col">
                    <div
                      className={`selectable-card ${
                        selectedSourceDatabase === db ? "selected" : ""
                      }`}
                      onClick={() => handleDatabaseSelect(db, true)}
                    >
                      <div className="db-logo-wrapper">
                        <img
                          src={getDatabaseImagePath(db)}
                          onError={(e) => {
                            console.error(
                              "Failed to load image:",
                              e.target.src
                            );
                            e.target.src = getDatabaseImagePath(db).replace(
                              ".png",
                              ".jpg"
                            );
                          }}
                          alt={db}
                          style={getCustomImageStyle(db)}
                          className="db-logo"
                        />
                      </div>
                      <p className="custom-card-text">{db}</p>
                      {selectedSourceDatabase === db && (
                        <div className="selected-overlay">
                          <img
                            src="assets/images/checkbox.png"
                            className="selected-check"
                            alt="Selected"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {selectedSourceDatabase &&
                renderConnectionFields(
                  sourceFields,
                  sourceConnection,
                  setSourceConnection,
                  true
                )}
            </>
          )}
        </>
      ),
    },

    2: {
      title:
        "Choose Target Database Server and Target Database Connection Details",
      description:
        "Select a target database and enter its connection details to proceed with migration",
      content: (
        <>
          <h6 className="fw-sbold font-size-12">Job Name</h6>
          <p className="font-size-12 text-dark">{jobName || "Not specified"}</p>

          <h6 className="fw-sbold font-size-12">Job Description</h6>
          <p className="font-size-12 text-dark">{jobDescription || "N/A"}</p>

          <h6 className="fw-sbold font-size-12">Type of Source Database</h6>
          <p className="font-size-12 text-dark mb-3">
            {selectedSourceDatabase || "Not specified"}
          </p>

          <h6 className="fw-sbold font-size-12">Select Target Database</h6>

          {loadingPlatforms ? (
            <div className="grid-container ms-2 mb-4">
              {/* Placeholder for target database loading */}
              <div
                className="grid-item loadingStyle"
                style={{ height: "80px" }}
              >
                <div
                  className="loadingStyle"
                  style={{
                    width: "45px",
                    height: "27px",
                    margin: "0 auto 8px",
                  }}
                ></div>
              </div>
            </div>
          ) : (
            <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-6 g-2 ms-2 mb-4">
              {getTargetDatabases().map((db) => (
                <div key={db} className="col">
                  <div
                    className={`selectable-card ${
                      selectedTargetDatabase === db ? "selected" : ""
                    }`}
                    onClick={() => handleDatabaseSelect(db, false)}
                  >
                    <div className="db-logo-wrapper">
                      <img
                        src={getDatabaseImagePath(db)}
                        onError={(e) => {
                          e.target.src = getDatabaseImagePath(db).replace(
                            ".png",
                            ".jpg"
                          );
                        }}
                        alt={db}
                        style={getCustomImageStyle(db)}
                        className="db-logo"
                      />
                    </div>
                    <p className="custom-card-text">{db}</p>
                    {selectedTargetDatabase === db && (
                      <div className="selected-overlay">
                        <img
                          src="assets/images/checkbox.png"
                          className="selected-check"
                          alt="Selected"
                        />
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Only show connection details section after target is selected */}
          {selectedTargetDatabase && (
            <>
              {/* <h6 className="fw-sbold font-size-12 mt-3">Target Database Connection Details</h6> */}

              {loadingFields ? (
                <div className="connection-fields-container mt-2">
                  {/* Textbox-shaped loaders */}
                  <div
                    className="loadingStyle mb-3"
                    style={{
                      height: "38px",
                      borderRadius: "4px",
                      width: "100%",
                    }}
                  ></div>
                  <div
                    className="loadingStyle mb-3"
                    style={{
                      height: "38px",
                      borderRadius: "4px",
                      width: "100%",
                    }}
                  ></div>
                  <div
                    className="loadingStyle mb-3"
                    style={{
                      height: "38px",
                      borderRadius: "4px",
                      width: "100%",
                    }}
                  ></div>
                  <div
                    className="loadingStyle mb-3"
                    style={{
                      height: "38px",
                      borderRadius: "4px",
                      width: "100%",
                    }}
                  ></div>
                  <div
                    className="loadingStyle mb-3"
                    style={{
                      height: "38px",
                      borderRadius: "4px",
                      width: "100%",
                    }}
                  ></div>
                </div>
              ) : (
                renderConnectionFields(
                  targetFields,
                  targetConnection,
                  setTargetConnection,
                  false
                )
              )}
            </>
          )}
        </>
      ),
    },
    3: {
      title: "Configure Migration Type & Scope",
      description: "Select tables to migrate from the available schemas",
      content: (
        <>
          <div className="mb-4">
            <h6 className="fw-sbold font-size-12">Job Name</h6>
            <p className="font-size-12 text-dark">
              {jobName || "Not specified"}
            </p>

            <h6 className="fw-sbold font-size-12">Job Description</h6>
            <p className="font-size-12 text-dark">{jobDescription || "N/A"}</p>

            <h6 className="fw-sbold font-size-12">Source Database</h6>
            <p className="font-size-12 text-dark">
              {selectedSourceDatabase || "Not specified"}
            </p>

            <h6 className="fw-sbold font-size-12 mt-3">Target Database</h6>
            <p className="font-size-12 text-dark">
              {selectedTargetDatabase || "Not specified"}
            </p>
          </div>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="fw-sbold font-size-12 mb-0">Select Tables</h6>
            {sampleTables.schemas &&
              Object.keys(sampleTables.schemas).length > 0 && (
                <button
                  onClick={handleSelectAllTables}
                  className="btn btn-link p-0 font-size-12"
                  style={{ color: "#202B3E" }}
                >
                  {(() => {
                    // Calculate total number of tables across all schemas
                    const allTables = Object.entries(
                      sampleTables.schemas
                    ).flatMap(([schemaName, tables]) =>
                      tables.map((table) => `${schemaName}.${table}`)
                    );

                    // Check if all tables are selected
                    const allSelected =
                      allTables.length > 0 &&
                      allTables.every((table) => checkedTables.includes(table));

                    return allSelected ? "Deselect All" : "Select All";
                  })()}
                </button>
              )}
          </div>

          {isLoading ? (
            <div className="schema-container">
              <div className="schema-list">
                <div className="schema-header border-top border-bottom py-2 mb-2">
                  <span className="font-size-12 fw-medium">Schemas</span>
                </div>

                {/* Loading placeholders for schemas */}
                <div className="row g-2">
                  {[1, 2, 3].map((schema) => (
                    <div key={schema} className="col-md-12">
                      <div
                        className="d-flex justify-content-between align-items-center p-2 cursor-pointer schema-item loadingStyle"
                        style={{
                          border: "1px solid #dee2e6",
                          marginTop: "-9px",
                          marginBottom: "-5px",
                          height: "40px",
                        }}
                      >
                        <div className="d-flex align-items-center">
                          <div
                            className="loadingStyle"
                            style={{
                              width: "16px",
                              height: "16px",
                              marginRight: "8px",
                              borderRadius: "3px",
                            }}
                          ></div>
                          <div
                            className="loadingStyle"
                            style={{
                              width: "100px",
                              height: "12px",
                              borderRadius: "3px",
                            }}
                          ></div>
                        </div>
                        <div
                          className="loadingStyle"
                          style={{
                            width: "10px",
                            height: "10px",
                            borderRadius: "3px",
                          }}
                        ></div>
                      </div>

                      {/* Loading placeholders for tables */}
                      <div className="table-list ms-9 mt-2 ps-3">
                        {[1, 2].map((table) => (
                          <div
                            key={table}
                            className="d-flex align-items-center mb-1 py-1 table-item loadingStyle"
                            style={{
                              position: "relative",
                              height: "30px",
                            }}
                          >
                            <div
                              className="horizontal-line"
                              style={{
                                position: "absolute",
                                left: "-16px",
                                top: "50%",
                                width: "16px",
                                height: "1px",
                                backgroundColor: "#dee2e6",
                              }}
                            />
                            <div
                              className="loadingStyle"
                              style={{
                                width: "16px",
                                height: "16px",
                                marginLeft: "12px",
                                marginRight: "8px",
                                borderRadius: "3px",
                              }}
                            ></div>
                            <div
                              className="loadingStyle"
                              style={{
                                width: "80px",
                                height: "12px",
                                borderRadius: "3px",
                              }}
                            ></div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : sampleTables.schemas &&
            Object.keys(sampleTables.schemas).length > 0 ? (
            <div className="schema-container">
              <div className="schema-list">
                <div className="schema-header border-top border-bottom py-2 mb-2">
                  <span className="font-size-12 fw-medium">Schemas</span>
                </div>

                <div className="row g-2">
                  {Object.entries(sampleTables.schemas).map(
                    ([schemaName, tables]) => {
                      const normalizedSchema = schemaName.trim().toLowerCase();
                      const isSchemaExpanded = expandedSchemas[schemaName];
                      const allTablesChecked =
                        tables.length > 0 &&
                        tables.every((table) =>
                          checkedTables.some(
                            (ct) =>
                              ct.toLowerCase() ===
                              `${schemaName.toLowerCase()}.${table.toLowerCase()}`
                          )
                        );

                      return (
                        <div key={schemaName} className="col-md-12">
                          <div
                            className="d-flex justify-content-between align-items-center p-2 cursor-pointer schema-item"
                            style={{
                              border: "1px solid #dee2e6",
                              marginTop: "-9px",
                              marginBottom: "-1px",
                            }}
                            onClick={() => handleSchemaToggle(schemaName)}
                          >
                            <div className="d-flex align-items-center">
                              <input
                                type="checkbox"
                                className="custom-checkbox mr-2"
                                id={`schema-${schemaName}`}
                                checked={
                                  isSchemaChecked(schemaName, tables) === true
                                }
                                ref={(el) => {
                                  if (el) {
                                    el.indeterminate =
                                      isSchemaChecked(schemaName, tables) ===
                                      "indeterminate";
                                  }
                                }}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  const normalizedSchema =
                                    schemaName.toLowerCase();
                                  const allSchemaTables = tables.map(
                                    (table) => `${schemaName}.${table}`
                                  );

                                  if (
                                    isSchemaChecked(schemaName, tables) === true
                                  ) {
                                    // Uncheck all
                                    setCheckedTables((prev) =>
                                      prev.filter(
                                        (t) =>
                                          !t
                                            .toLowerCase()
                                            .startsWith(`${normalizedSchema}.`)
                                      )
                                    );
                                  } else {
                                    // Check all
                                    setCheckedTables((prev) => {
                                      const filtered = prev.filter(
                                        (t) =>
                                          !t
                                            .toLowerCase()
                                            .startsWith(`${normalizedSchema}.`)
                                      );
                                      return [...filtered, ...allSchemaTables];
                                    });
                                  }
                                }}
                                style={{ marginRight: "8px" }}
                              />
                              <label
                                htmlFor={`schema-${schemaName}`}
                                className="font-size-12 schema-label"
                                style={{ color: "#202B3E" }}
                              >
                                {schemaName}
                              </label>
                            </div>

                            <div className="d-flex align-items-center">
                              <i
                                className={`fas fa-chevron-${
                                  isSchemaExpanded ? "down" : "right"
                                }`}
                                style={{ fontSize: "10px" }}
                              />
                            </div>
                          </div>

                          {expandedSchemas[schemaName] && (
                            <div className="table-list ms-9 mt-2 ps-3">
                              {tables.map((table, index) => {
                                const isChecked = checkedTables.some(
                                  (ct) =>
                                    ct.toLowerCase() ===
                                    `${schemaName.toLowerCase()}.${table.toLowerCase()}`
                                );
                                const isLastTable = index === tables.length - 1;

                                return (
                                  <div
                                    key={table}
                                    className="d-flex align-items-center mb-1 py-1 table-item"
                                    style={{ position: "relative" }}
                                  >
                                    <div
                                      className="horizontal-line"
                                      style={{
                                        position: "absolute",
                                        left: "-16px",
                                        top: "50%",
                                        width: "16px",
                                        height: "1px",
                                        backgroundColor: "#dee2e6",
                                      }}
                                    />

                                    <input
                                      type="checkbox"
                                      className="custom-checkbox mr-2"
                                      id={`table-${schemaName}-${table}`}
                                      checked={isChecked}
                                      onChange={() =>
                                        handleTableSelect(schemaName, table)
                                      }
                                      style={{
                                        zIndex: 1,
                                        marginLeft: "12px !important",
                                        marginRight: "8px",
                                      }}
                                    />

                                    <label
                                      htmlFor={`table-${schemaName}-${table}`}
                                      className="table-label font-size-12"
                                      style={{ color: "#202B3E" }}
                                    >
                                      {table}
                                    </label>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center py-3">
              <p className="font-size-12 text-muted">
                No schemas found in the source database
              </p>
              {sampleTables.message && (
                <p className="font-size-12 text-muted mt-2">
                  {sampleTables.message}
                </p>
              )}
            </div>
          )}
        </>
      ),
    },

    // Inside the step 4 content (replace the current step 4 content with this)
    4: {
      title: "Start Migration & Track Progress",
      description: "Do this before you migrate to ensure a smooth transition",
      content: (
        <>
          <style>
            {`
          @keyframes pulse {
            0% { opacity: 0.6; }
            50% { opacity: 0.3; }
            100% { opacity: 0.6; }
          }
        `}
          </style>

          <div className="step4css">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="mb-0 Migratingdatabase">
                Migrating database:{" "}
                {jobProgressData?.jobName || jobDetails?.job_name || ""}
              </h6>
              <span className="font-size-12 fw-bold">
                {jobProgressData?.progressBar?.tableProgressPercent || 0}%
              </span>
            </div>
            <div className="progress mb-3 step4Database">
              <div
                className="progress-colorclass"
                role="progressbar"
                style={{
                  width: `${
                    jobProgressData?.progressBar?.tableProgressPercent || 0
                  }%`,
                }}
                aria-valuenow={
                  jobProgressData?.progressBar?.tableProgressPercent || 0
                }
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>

          <div
            className="d-flex justify-content-between mb-3"
            style={{ gap: "15px", marginTop: "14px" }}
          >
            <div className="flex-grow-1">
              <div className="p-2 text-center step4cssBox">
                <div className="step4cssTypo">
                  {jobProgressData?.schemasCompleted || 0}
                </div>
              </div>
              <div className="text-center mt-1 step4cssText">
                Schema completed
              </div>
            </div>

            <div className="flex-grow-1">
              <div className="p-2 text-center step4cssBox">
                <div className="step4cssTypo">
                  {jobProgressData?.tablesCompleted || 0}
                </div>
              </div>
              <div className="text-center mt-1 step4cssText">
                Tables completed
              </div>
            </div>

            <div className="flex-grow-1">
              <div className="p-2 text-center step4cssBox">
                <div className="step4cssTypo">
                  {jobProgressData?.schemasInProgress || 0}
                </div>
              </div>
              <div className="text-center mt-1 step4cssText">
                Schema in progress
              </div>
            </div>

            <div className="flex-grow-1">
              <div className="p-2 text-center step4cssBox">
                <div className="step4cssTypo">
                  {jobProgressData?.tablesInProgress || 0}
                </div>
              </div>
              <div className="text-center mt-1 step4cssText">
                Tables in progress
              </div>
            </div>
          </div>

          <div className="p-3 card-calc" style={logContainerStyle}>
            {isLogLoading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "200px" }}
              >
                <img
                  src={loading || "/placeholder.svg"}
                  alt="Loading..."
                  style={{ width: "20%", height: "auto" }}
                />
              </div>
            ) : logs?.length > 0 ? (
              <div
                className="log-container"
                style={{ fontSize: "14px", fontFamily: "Helvetica" }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 2fr",
                    gap: "16px",
                    paddingBottom: "8px",
                  }}
                >
                  <div style={{ color: "white" }}>Timestamp</div>
                  <div style={{ color: "white", marginLeft: "30px" }}>
                    Table Name
                  </div>
                  <div style={{ color: "white" }}>Summary</div>
                </div>

                {logs.map((log, index) => (
                  <div
                    key={index}
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 2fr",
                      gap: "16px",
                      padding: "6px 0",
                      fontSize: "12px",
                      fontFamily: "'JetBrains Mono', monospace",
                      minHeight: "40px",
                      alignItems: "flex-start",
                    }}
                  >
                    <div
                      style={{
                        color: "white",
                        wordBreak: "break-word",
                        overflow: "hidden",
                      }}
                    >
                      {log.timestamp}
                    </div>
                    <div
                      style={{
                        color: "white",
                        wordBreak: "break-word",
                        overflow: "hidden",
                        marginLeft: "30px",
                      }}
                    >
                      {log.table_name || "N/A"}
                    </div>
                    <div
                      style={{
                        color: "white",
                        wordBreak: "break-word",
                      }}
                    >
                      {highlightKeywords(log.message)}
                    </div>
                  </div>
                ))}

                {isStreaming && !jobProcessCompleted && (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 2fr",
                      gap: "16px",
                      padding: "6px 0",
                      fontSize: "12px",
                      fontFamily: "'JetBrains Mono', monospace",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <div
                        style={{
                          width: "66%",
                          height: "14px",
                          backgroundColor: "rgb(160 168 181 / 31%)",
                          borderRadius: "2px",
                          animation: "pulse 1.5s infinite",
                        }}
                      ></div>
                    </div>
                    <div>
                      <div
                        style={{
                          width: "50%",
                          height: "14px",
                          marginLeft: "27px",
                          backgroundColor: "rgb(160 168 181 / 31%)",
                          borderRadius: "2px",
                          animation: "pulse 1.5s infinite",
                        }}
                      ></div>
                    </div>
                    <div>
                      <div
                        style={{
                          width: "97%",
                          height: "14px",
                          backgroundColor: "rgb(160 168 181 / 31%)",
                          borderRadius: "2px",
                          animation: "pulse 1.5s infinite",
                        }}
                      ></div>
                      <div
                        style={{
                          width: "80%",
                          height: "14px",
                          backgroundColor: "rgb(160 168 181 / 31%)",
                          borderRadius: "2px",
                          marginTop: "4px",
                          animation: "pulse 1.5s infinite",
                          animationDelay: "0.3s",
                        }}
                      ></div>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div
                className="d-flex flex-column justify-content-center align-items-center"
                style={{ height: "200px" }}
              >
                <img
                  src={nologs || "/placeholder.svg"}
                  alt="No Logs..."
                  style={{ width: "30%", height: "auto" }}
                />
                <p>No Logs Available</p>
              </div>
            )}
          </div>
        </>
      ),
    },
    // 4: {
    //   title: "Start Migration & Track Progress",
    //   description: "Do this before you migrate to ensure a smooth transition",
    //   content: (
    //     <>
    //       <style>
    //         {`
    //           @keyframes pulse {
    //             0% { opacity: 0.6; }
    //             50% { opacity: 0.3; }
    //             100% { opacity: 0.6; }
    //           }
    //         `}
    //       </style>

    //       <div className="step4css">
    //         <div className="d-flex justify-content-between align-items-center mb-3">
    //           <h6 className="mb-0 Migratingdatabase">
    //             Migrating database: {jobProgressData?.jobName || jobDetails?.job_name || ""}
    //           </h6>
    //           <span className="font-size-12 fw-bold">{jobProgressData?.progressBar?.tableProgressPercent || 0}%</span>
    //         </div>
    //         <div className="progress mb-3 step4Database">
    //           <div
    //             className="progress-colorclass"
    //             role="progressbar"
    //             style={{
    //               width: `${jobProgressData?.progressBar?.tableProgressPercent || 0}%`,
    //             }}
    //             aria-valuenow={jobProgressData?.progressBar?.tableProgressPercent || 0}
    //             aria-valuemin="0"
    //             aria-valuemax="100"
    //           ></div>
    //         </div>
    //       </div>

    //       <div className="d-flex justify-content-between mb-3" style={{ gap: "15px", marginTop: "14px" }}>
    //         <div className="flex-grow-1">
    //           <div className="p-2 text-center step4cssBox">
    //             <div className="step4cssTypo">{jobProgressData?.schemasCompleted || 0}</div>
    //           </div>
    //           <div className="text-center mt-1 step4cssText">Schema completed</div>
    //         </div>

    //         <div className="flex-grow-1">
    //           <div className="p-2 text-center step4cssBox">
    //             <div className="step4cssTypo">{jobProgressData?.tablesCompleted || 0}</div>
    //           </div>
    //           <div className="text-center mt-1 step4cssText">Tables completed</div>
    //         </div>

    //         <div className="flex-grow-1">
    //           <div className="p-2 text-center step4cssBox">
    //             <div className="step4cssTypo">{jobProgressData?.schemasInProgress || 0}</div>
    //           </div>
    //           <div className="text-center mt-1 step4cssText">Schema in progress</div>
    //         </div>

    //         <div className="flex-grow-1">
    //           <div className="p-2 text-center step4cssBox">
    //             <div className="step4cssTypo">{jobProgressData?.tablesInProgress || 0}</div>
    //           </div>
    //           <div className="text-center mt-1 step4cssText">Tables in progress</div>
    //         </div>
    //       </div>

    //       <div className="p-3 card-calc" style={logContainerStyle}>
    //         {isLogLoading ? (
    //           <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
    //             <img src={loading || "/placeholder.svg"} alt="Loading..." style={{ width: "20%", height: "auto" }} />
    //           </div>
    //         ) : logs?.length > 0 ? (
    //           <div className="log-container" style={{ fontSize: "14px", fontFamily: "Helvetica" }}>
    //             <div
    //               style={{
    //                 display: "flex",
    //                 paddingBottom: "8px",
    //               }}
    //             >
    //               <div
    //                 style={{
    //                   width: "23%",
    //                   color: "white",
    //                   paddingRight: "16px",
    //                 }}
    //               >
    //                 Timestamp
    //               </div>
    //               <div
    //                 style={{
    //                   width: "26%",
    //                   color: "white",
    //                   paddingRight: "16px",
    //                   paddingLeft: "0px",
    //                 }}
    //               >
    //                 Table Name
    //               </div>
    //               <div
    //                 style={{
    //                   width: "52%",
    //                   color: "white",
    //                   paddingLeft: "16px",
    //                 }}
    //               >
    //                 Summary
    //               </div>
    //             </div>

    //             {logs.map((log, index) => (
    //               <div
    //                 key={index}
    //                 style={{
    //                   display: "flex",
    //                   padding: "6px 0",
    //                   fontSize: "12px",
    //                   fontFamily: "'JetBrains Mono', monospace",
    //                   minHeight: "40px",
    //                   alignItems: "flex-start",
    //                 }}
    //               >
    //                 <div
    //                   style={{
    //                     width: "23%",
    //                     color: "white",
    //                     paddingRight: "16px",
    //                     overflow: "hidden",
    //                     textOverflow: "ellipsis",
    //                     whiteSpace: "nowrap",
    //                   }}
    //                 >
    //                   {log.timestamp}
    //                 </div>
    //                 <div
    //                   style={{
    //                     width: "26%",
    //                     color: "white",
    //                     paddingRight: "16px",
    //                     overflow: "hidden",
    //                     textOverflow: "ellipsis",
    //                     wordBreak: "break-word",
    //                     whiteSpace: "normal",
    //                   }}
    //                 >
    //                   {log.table_name || "N/A"}
    //                 </div>
    //                 <div
    //                   style={{
    //                     width: "52%",
    //                     color: "white",
    //                     paddingLeft: "16px",
    //                     wordBreak: "break-word",
    //                   }}
    //                 >
    //                   {highlightKeywords(log.message)}
    //                 </div>
    //               </div>
    //             ))}

    //             {isStreaming && !jobProcessCompleted && (
    //               <div
    //                 style={{
    //                   display: "flex",
    //                   padding: "6px 0",
    //                   fontSize: "12px",
    //                   fontFamily: "'JetBrains Mono', monospace",
    //                   alignItems: "center",
    //                 }}
    //               >
    //                 <div style={{ flex: 2, paddingRight: "12px" }}>
    //                   <div
    //                     style={{
    //                       width: "100%",
    //                       height: "14px",
    //                       backgroundColor: "rgb(160 168 181 / 31%)",
    //                       borderRadius: "2px",
    //                       animation: "pulse 1.5s infinite",
    //                     }}
    //                   ></div>
    //                 </div>
    //                 <div style={{ flex: 1, paddingRight: "12px" }}>
    //                   <div
    //                     style={{
    //                       width: "40%",
    //                       height: "14px",
    //                       backgroundColor: "rgb(160 168 181 / 31%)",
    //                       borderRadius: "2px",
    //                       animation: "pulse 1.5s infinite",
    //                     }}
    //                   ></div>
    //                 </div>
    //                 <div style={{ flex: 3, minWidth: 0 }}>
    //                   <div
    //                     style={{
    //                       width: "90%",
    //                       height: "14px",
    //                       backgroundColor: "rgb(160 168 181 / 31%)",
    //                       borderRadius: "2px",
    //                       animation: "pulse 1.5s infinite",
    //                     }}
    //                   ></div>
    //                   <div
    //                     style={{
    //                       width: "70%",
    //                       height: "14px",
    //                       backgroundColor: "rgb(160 168 181 / 31%)",
    //                       borderRadius: "2px",
    //                       marginTop: "4px",
    //                       animation: "pulse 1.5s infinite",
    //                       animationDelay: "0.3s",
    //                     }}
    //                   ></div>
    //                 </div>
    //               </div>
    //             )}
    //           </div>
    //         ) : (
    //           <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: "200px" }}>
    //             <img src={nologs || "/placeholder.svg"} alt="No Logs..." style={{ width: "30%", height: "auto" }} />
    //             <p>No Logs Available</p>
    //           </div>
    //         )}
    //       </div>
    //     </>
    //   ),
    // },
  };

  return (
    <div>
      <div
        className={`right-bar3 p-3 ${show ? "d-block" : "d-none"}`}
        style={modalStyle}
      >
        <div>
          <div className="d-flex align-items-center justify-content-between">
            <h6 className="font-size-13 mb-0 fw-medium text-dark">
              Data Migration
            </h6>
            <CustomTooltip
              content="Close"
              placement="left"
              fallbackPlacements={["bottom"]}
            >
              <i
                onClick={handleClose}
                className="mdi mdi-close close-trace cursor-pointer right-bar-toggle3 iconColor"
              />
            </CustomTooltip>
          </div>
          <div className="trace-label  mt-1 pe-3 d-flex align-items-center mb-3 w-fit-content">
            <img
              src="/assets/images/trace_label.png"
              className="w-14px me-2"
              alt="Job icon"
            />
            <h6 className="font-size-10 mb-0 text-dark">
              Create Job – Set up a new migration task
            </h6>
          </div>

          <p className="mb-1  font-size-12 text-dark">
            Step {DatabaseStep} of 4
          </p>

          <h6 className="fw-bold">{stepInfo[DatabaseStep].title}</h6>

          <p className="font-size-12 text-dark">
            {stepInfo[DatabaseStep].description}
          </p>

          <div className="stepper-container">
            {[1, 2, 3, 4].map((step) => (
              <div key={step} className="stepper">
                <div
                  className={`step ${
                    DatabaseStep === step
                      ? "active"
                      : DatabaseStep > step
                      ? "completed"
                      : ""
                  }`}
                  data-step={step}
                >
                  {step}
                </div>

                {step < 4 && (
                  <div className="line-container">
                    <div
                      className={`line ${
                        DatabaseStep > step ? "completed" : ""
                      }`}
                    ></div>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div
            id="stepContent"
            style={{
              maxHeight:
                DatabaseStep === 4
                  ? "calc(100vh - 280px)"
                  : "calc(100vh - 309px)",
              overflowY: "auto",
              overflowX: "hidden",
              paddingLeft: "12px",
              paddingRight: "12px",
              marginLeft: "-14px",
              marginRight: "-14px",
            }}
          >
            {stepInfo[DatabaseStep].content}
          </div>

          <div className="position-absolute close-tab">
            <div
              className="d-flex justify-content-between align-items-center w-100"
              style={{ marginBottom: "10px" }}
            >
              <button
                onClick={handleClose}
                className="btn btn-closebtn custom-button"
              >
                Close
              </button>

              <div className="d-flex gap-2" style={{ marginRight: "2px" }}>
                {/* Previous button remains same */}
                {DatabaseStep > 1 && DatabaseStep < 4 && (
                  <button
                    onClick={handlePrevious}
                    className="btn btn-closebtn custom-button"
                  >
                    Previous
                  </button>
                )}

                {/* Test Connection button */}
                {(DatabaseStep === 1 || DatabaseStep === 2) && (
                  <button
                    onClick={() => handleTestConnection(DatabaseStep === 1)}
                    className="btn btn-closebtn custom-button"
                    disabled={
                      DatabaseStep === 1
                        ? !isDatabaseSelected
                        : !selectedTargetDatabase
                    }
                  >
                    Test Connection
                  </button>
                )}

                {/* Next button with exact logic you want */}
                {DatabaseStep < 4 ? (
                  DatabaseStep === 3 ? (
                    isJobCreated ? (
                      <button
                        onClick={handleStartMigration}
                        className="btn btn-primary custom-button"
                        disabled={isMigrationStarting}
                      >
                        {isMigrationStarting
                          ? "Starting..."
                          : "Start Migration"}
                      </button>
                    ) : (
                      <button
                        onClick={handleNext}
                        className="btn btn-primary custom-button"
                        disabled={checkedTables.length === 0}
                      >
                        Next
                      </button>
                    )
                  ) : (
                    <button
                      onClick={handleNext}
                      className="btn btn-primary custom-button"
                      disabled={
                        (DatabaseStep === 1 &&
                          !(
                            jobName.trim() &&
                            selectedSourceDatabase &&
                            connectionTestStatus.source === true
                          )) ||
                        (DatabaseStep === 2 &&
                          !(
                            selectedTargetDatabase &&
                            connectionTestStatus.target === true
                          ))
                      }
                    >
                      Next
                    </button>
                  )
                ) : (
                  <button
                    onClick={handleClose}
                    className="btn btn-primary custom-button"
                    style={{ marginRight: "-7px" }}
                  >
                    Minimize and Continue in Background
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`rightbar-overlay ${show ? "d-block" : "d-none"}`}></div>
    </div>
  );
}

export default memo(CreateDatabase);
